<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 筛选选项区域 -->
      <div class="screen">
        <el-form
          ref="form"
          :model="screen"
          label-width="80px"
          label-position="top"
        >
          <el-form-item label="公司名称" class="inputlength">
            <el-input
              v-model="screen.name"
              size="small"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" class="inputlength">
            <el-input
              v-model="screen.mobile"
              size="small"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核状态" class="inputlength">
            <el-select
              v-model="screen.is_auth"
              placeholder="请选择"
              size="small"
            >
              <el-option label="待审核" value="0"> </el-option>
              <el-option label="审核不通过" value="1"> </el-option>
              <el-option label="通过" value="2"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button
            type="primary"
            size="small"
            @click="$router.push('set/seting')"
            >车队卡设置</el-button
          >
          <el-button
            style="margin-left:30px"
            type="primary"
            size="small"
            @click="move"
            >移至分组</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="success"
            size="small"
            icon="el-icon-search"
            @click="searchMethods"
            >查询</el-button
          >
          <!-- <el-button type="warning" size="small">导出数据</el-button> -->
        </div>
      </div>
      <!-- 列表 -->
      <el-table
        v-loading="loading"
        element-loading-text="数据加载中..."
        :data="listData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="公司名称" prop="name"></el-table-column>
        <el-table-column label="电话" prop="mobile"></el-table-column>
        <el-table-column
          label="预估金额"
          prop="estimated_amount"
        ></el-table-column>
        <el-table-column label="余额" prop="collect.balance"></el-table-column>
        <el-table-column
          label="消费"
          prop="collect.consume_amount"
        ></el-table-column>
        <el-table-column label="开户时间" prop="create_time"></el-table-column>
        <el-table-column label="审核状态" prop="auth"></el-table-column>
        <el-table-column width="165px" label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="update(scope.row.id)"
              >升级任务</el-button
            > -->
            <el-button type="text" @click="delList(scope.row.id)"
              >删除</el-button
            >
            <el-button type="text" @click="balance_logs(scope.row)"
              >余额变动记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 分組 -->
    <el-dialog
      title="移动分组"
      :visible.sync="dialogTableVisible"
      width="400px"
    >
      <el-button
        type="primary"
        size="small"
        style="margin-bottom: 10px;"
        @click="addGroup(0)"
        >添加分组</el-button
      >
      <el-form>
        <el-form-item label="车队卡分组">
          <el-select
            v-model="choseGroupId"
            placeholder="请选择分组"
            size="small"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in groupList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="getGroupMove">确 定</el-button>
      </div>
      <!-- 添加分组 -->
      <el-dialog
        width="30%"
        title="添加分组"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form label-width="100px">
          <el-form-item label="分组名称">
            <el-input size="small" v-model="groupName"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="addGroup(1)">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>

    <el-dialog title="余额记录" :visible.sync="dialogLogsVisible">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="车队类型">
          <el-select
            v-model="formdata.type_card_id"
            placeholder="车队类型"
            size="small"
          >
            <el-option
              v-for="(item, i) in options"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变动时间段">
          <el-date-picker
            size="small"
            v-model="logsDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search_logs" size="small"
            >查 询</el-button
          >
          <el-button type="primary" @click="export_logs" size="small"
            >导 出</el-button
          >
        </el-form-item>
      </el-form>
      <div style="display: flex;justify-content: space-around">
        <div>
          <span style="font-size: 18px">账户剩余: </span>
          <span style="font-size: 16px">{{ logs_Remaining }}</span>
        </div>
        <div>
          <span style="font-size: 18px;"> 总消费金额: </span>
          <span style="font-size: 16px">{{ counts_data.order }}</span>
        </div>
        <div>
          <span style="font-size: 18px;"> 总充值金额: </span>
          <span style="font-size: 16px">{{ counts_data.recharge }}</span>
        </div>
        <div>
          <span style="font-size: 18px;"> 后台总增加: </span>
          <span style="font-size: 16px">{{ counts_data.admin_inc }}</span>
        </div>
        <div>
          <span style="font-size: 18px;"> 后台总减少: </span>
          <span style="font-size: 16px">{{ counts_data.admin_dec }}</span>
        </div>
      </div>
      <el-divider></el-divider>
      <el-table :data="balance_logs_list">
        <el-table-column label="变动时间" prop="create_time"></el-table-column>
        <el-table-column label="变动类型" prop="type">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.type == 1
                  ? "增加"
                  : scope.row.type == 2
                  ? "减少"
                  : "记录"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="变动金额" prop="amount">
          <template slot-scope="scope">
            <div>
              <span style="color: red" v-if="scope.row.type == 2">- </span>
              <span style="color: red" v-if="scope.row.type == 1">+ </span>
              <span>{{ scope.row.amount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="变动说明" prop="text"></el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="logs_page"
        :total="logstotal"
        @current-change="handleCurrentChange_logs"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  cardList,
  groupAdd,
  groupList,
  groupMove,
  List,
  ListDel,
  team_balance_count,
  team_balance_logs
} from "@/api/motorcade";
import Judge from "@/components/vip/judgeDialog";
import { exportMethods } from "@/api/vip";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    Judge
  },
  inject: ["reload"],
  data() {
    return {
      loading: false,
      logstotal: 0,
      counts_data: {},
      logs_consume_amount: 0,
      logsDate: [],
      balance_logs_list: [],
      dialogLogsVisible: false,
      choseGroupId: "",
      groupList: [],
      choseMoveIds: [],
      groupName: "",
      listData: [],
      screen: {
        name: "",
        mobile: "",
        is_auth: ""
      },
      dialogTableVisible: false,
      innerVisible: false,
      page: 1,
      total: 0,
      menus: "加油卡",
      options: [], //任务类型
      showJudge: false,
      formdata: {
        app_id: "",
        team_id: "",
        type_card_id: ""
      },
      logs_Remaining: 0,
      logs_page: 1,
      limit: 10
    };
  },
  mounted() {
    //
    this.getList();
    this.getGroupList();
  },
  methods: {
    search_logs() {
      if (this.logsDate&&this.logsDate.length == 2) {
        this.formdata.start_time = this.logsDate[0];
        this.formdata.end_time = this.logsDate[1];
      }
      this.getLogs();
      this.get_count()
    },
    // 筛选
    searchMethods() {
      this.getList();
    },
    handleSelectionChange(val) {
      console.log("selecty", val);
      this.choseMoveIds = val;
    },
    move() {
      if (this.choseMoveIds.length == 0) {
        this.$message.warning("请选择要移动的车队");
      } else {
        this.dialogTableVisible = true;
      }
    },
    addGroup(status) {
      if (status == 0) {
        this.innerVisible = true;
      } else {
        groupAdd({
          token: this.token,
          app_id: this.app_id,
          name: this.groupName
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.groupName = "";
            this.innerVisible = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    },
    getList() {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.screen.name,
        mobile: this.screen.mobile,
        is_auth: this.screen.is_auth
      };
      List(data).then(res => {
        if (res.code == 200) {
          this.listData = res.result;
          this.total = res.total_num;
          for (var i = 0; i < this.listData.length; i++) {
            switch (this.listData[i].is_auth) {
              case 0:
                this.listData[i].auth = "待审核";
                break;
              case 1:
                this.listData[i].auth = "审核不通过";
                break;
              case 2:
                this.listData[i].auth = "通过";
                break;
            }
          }
          this.loading = false;
        } else {
          this.$message.warning(res.msg);
          this.loading = false;
        }
        console.log("列表", res);
      });
    },
    getGroupList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      groupList(data).then(res => {
        if (res.code == 200) {
          console.log("groupList", res);
          this.groupList = res.result;
        }
      });
    },
    delList(id) {
      this.$confirm("确定要删除该车队信息吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            token: this.token,
            app_id: this.app_id,
            id: id
          };
          ListDel(data).then(res => {
            if (res.code == 200) {
              this.$message.success("刪除成功！！");
              this.reload();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },
    getGroupMove() {
      if (this.choseMoveIds == "") {
        this.$message.warning("请选择要移动的分组！！");
        return;
      }

      let lilstIds = this.choseMoveIds.map(item => {
        return item.id;
      });
      this.$confirm("确定移至该分组吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            token: this.token,
            app_id: this.app_id,
            id: lilstIds.join(","),
            group_id: this.choseGroupId // 分组id
          };
          groupMove(data).then(res => {
            if (res.code == 200) {
              this.dialogTableVisible = false;
              this.reload();
              this.$message.success("移动分组成功！！");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getList();
    },
    handleCurrentChange_logs(val) {
      this.logs_page = val;
      this.getLogs();
    },
    export_logs() {
      let data = {
        Api: "teamcard/agent.team_card/team_balance_logs",
        app_id: this.app_id,
        params: [
          { name: "token", value: this.token },
          { name: "team_id", value: this.formdata.team_id },
          {
            name: "type_card_id",
            value: this.formdata.type_card_id
          },
          { name: "export_", value: 1 }
        ]
      };
      if (this.logsDate&&this.logsDate.length > 0) {
        data.params.push(
          {
            name: "start_time",
            value: this.logsDate[0]
          },
          {
            name: "end_time",
            value: this.logsDate[1]
          }
        );
      }
      exportMethods(data);
    },
    async balance_logs(row) {
      this.logs_Remaining = row.collect.balance;
      this.logs_consume_amount = row.collect.consume_amount;
      this.formdata.app_id = this.app_id;
      this.formdata.team_id = row.id;
      const res1 = await cardList({
        app_id: this.app_id
      });
      if (res1.code == 200) {
        console.log(res1.result);
        this.options = res1.result;
        this.formdata.type_card_id = res1.result[0].id;
      }
      await this.getLogs();
      await this.get_count();
      this.dialogLogsVisible = true;
      console.log(this.balance_logs_list);
    },
    async getLogs() {
      this.formdata.limit = this.limit;
      this.formdata.page = this.logs_page;
      const res2 = await team_balance_logs(this.formdata);
      this.balance_logs_list = res2.data.data;
      this.logstotal = res2.data.total;
      console.log(this.balance_logs_list);
    },
    async get_count() {
      let data = {
        app_id: this.app_id,
        team_id: this.formdata.team_id,
        type_card_id: this.formdata.type_card_id
      };
      const res = await team_balance_count(data);
      this.counts_data = res.data;
      console.log(res);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    // 筛选选项
    .screen {
      width: 100%;
      height: auto;
      .el-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }
      .inputlength {
        width: 191px;
        margin: 0 20px 0 0;
      }
    }
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        width: 400px;
      }
      .right {
        flex: 1;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img {
      width: 60px;
      height: 60px;
    }
    .table_checkbox {
      margin-bottom: 10px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    //分页
    .Otherpage {
      height: 54px;
      padding-top: 10px;
      width: 200px;
    }
    .task_form {
      margin-right: 20px;
      .short_input {
        width: 110px;
      }
      .normal_input {
        width: 350px;
      }
    }
    .bottom_btn {
      margin: 20px auto 0 auto;
      text-align: center;
    }
  }
}
</style>
<style>
.screen .el-form-item__label {
  line-height: 20px;
  padding: 10px 0 0 0 !important;
  font-weight: 550;
}
</style>
